import React, { useEffect } from "react";
import { TouchableOpacity, Image } from "react-native";
import { router, Href } from "expo-router";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { selectIsRTL } from "../../store/slices/appSlice";

// Import icons from web-nav-icons folder
import StockImage from "../../assets/web-nav-icons/stock-icon.png";
import SellImage from "../../assets/web-nav-icons/sell-icon.png";
import DeptImage from "../../assets/web-nav-icons/dept-icon.png";
import ReceiptImage from "../../assets/web-nav-icons/receipt-icon.png";
// Import Settings PNG (converted from SVG) as no match in web-nav-icons
import SettingsImage from "../../assets/web-nav-icons/gear-icon.png";
import DashboardImage from "../../assets/web-nav-icons/circle-stats.png";
import OrdersImage from "../../assets/web-nav-icons/receipt-icon.png";

interface SidebarItem {
  id: string;
  imageSource: any;
  url: string;
  urlWithoutScanner?: string;
}

const WebSidebar: React.FC = () => {
  const { sellWithScanner, locale } = useSelector(
    (state: RootState) => state.app
  );

  // Use Redux selector for RTL - single source of truth
  const isRTL = useSelector(selectIsRTL);

  // Update document direction when RTL changes - applies to all screens using this sidebar
  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.style.direction = isRTL ? "rtl" : "ltr";
    }
  }, [isRTL]);

  const sidebarItems: SidebarItem[] = [
    {
      id: "sell",
      imageSource: SellImage,
      url: "scanner",
      urlWithoutScanner: "scannerwithout",
    },
    {
      id: "stock",
      imageSource: StockImage,
      url: "stock",
    },
    {
      id: "statistics",
      imageSource: DashboardImage,
      url: "statistics",
    },
    {
      id: "bills",
      imageSource: ReceiptImage,
      url: "bills",
    },
    {
      id: "debts",
      imageSource: DeptImage,
      url: "dettes",
    },
    {
      id: "orders",
      imageSource: OrdersImage,
      url: "orders",
    },
    {
      id: "settings",
      imageSource: SettingsImage,
      url: "params",
    },
  ];

  const handleNavigation = (item: SidebarItem) => {
    if (item.id === "sell") {
      router.push(
        (sellWithScanner
          ? item.url
          : item.urlWithoutScanner || item.url) as Href
      );
    } else {
      router.push(item.url as Href);
    }
  };

  const handleLogoPress = () => {
    router.push("/(drawer)/start" as Href);
  };

  return (
    <div
      key={`sidebar-${locale}`}
      className="w-[70px] bg-[#1379A2] py-5 flex flex-col items-center"
    >
      {/* Logo - Clickable to go to Start */}
      <TouchableOpacity
        className="mb-8 p-2"
        onPress={handleLogoPress}
        activeOpacity={0.7}
      >
        <Image
          source={require("../../assets/logo-icon-no-bg.png")}
          style={{ width: 40, height: 40 }}
          resizeMode="contain"
        />
      </TouchableOpacity>

      {/* Navigation Items */}
      <div className="flex-1 w-full flex flex-col items-center gap-1.5">
        {sidebarItems.map((item) => (
          <TouchableOpacity
            key={item.id}
            className="w-12 h-12 rounded-xl items-center justify-center bg-white/15 my-1"
            onPress={() => handleNavigation(item)}
            activeOpacity={0.7}
          >
            <Image
              source={item.imageSource}
              style={{ width: 28, height: 28 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
        ))}
      </div>
    </div>
  );
};

export default WebSidebar;
